import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { __, getLocalized } from '../../../core/utils';
import {
  hideDropdown,
  showDropdown,
} from '../../../redux/actions/general/dropdown';
import { listPlanningLibraryItems } from '../../../redux/actions/table/planning_library';
import SearchableDropdown from '../../../components/SearchableDropdown';
import styles from '../../../styles/views/company/PlanningTemplates.scss';

const TYPE_LABELS = {
  stage: 'Stage',
  substage: 'Substage',
  group: 'Group',
};

const PlanningTemplateLibraryDropdown = ({
  isSystem = false,
  languageId,
  picker,
  onClose,
  onSelect,
}) => {
  const [items, setItems] = useState([]);
  const name = `planning-template-library-${picker.key}`;
  const typeLabel = __(
    `planning-templates.type.${picker.type}`,
    {},
    TYPE_LABELS[picker.type]
  );

  useEffect(() => {
    listPlanningLibraryItems(picker.type, isSystem, true).then(
      ({ response }) => {
        setItems(
          _.map(response.data, (item) => {
            const localizedName = getLocalized(item.name, languageId);

            return {
              ...item,
              value: item.id,
              label: item.code
                ? `${localizedName} · ${item.code}`
                : localizedName,
              is_company: !item.is_system,
              source_tooltip: item.is_system
                ? __('planning-templates.source.system')
                : __('planning-templates.source.my-company'),
            };
          }),
        );
      },
    );

    showDropdown(name);
  }, []);

  const selectItem = (item) => {
    hideDropdown();
    onSelect(item);
  };

  return ReactDOM.createPortal(
    <div
      className={styles.libraryDropdownAnchor}
      style={{ left: picker.left, top: picker.top }}
    >
      <SearchableDropdown
        showSearchInput
        showIcon
        leftStyled
        top={4}
        name={name}
        options={items}
        onSelect={selectItem}
        onButtonClick={onClose}
        buttonLabel={__('button.cancel')}
        dropdownWrapperClassName={styles.libraryDropdownWrapper}
        dropdownContentClassName={styles.libraryDropdownContent}
        header={
          <div className={styles.libraryDropdownHeader}>
            <strong>
              {__(
                'planning-templates.library-picker.title',
                { type: typeLabel },
                `Add ${typeLabel}`
              )}
            </strong>
            <span>{__('planning-templates.library-picker.subtitle')}</span>
          </div>
        }
      >
        <span className={styles.libraryDropdownTrigger} />
      </SearchableDropdown>
    </div>,
    document.body
  );
};

export default PlanningTemplateLibraryDropdown;
